import { RootState } from '../../store-config';
import { CareCoordinator } from 'types/care-coordinator.types';

export const selectCareCoordinators = (state: RootState): CareCoordinator[] =>
  state.careCoordinatorState.careCoordinators;

export const selectCareCoordinatorsLoading = (state: RootState): boolean => state.careCoordinatorState.loading;
